export default __webpack_public_path__ + "static/media/crypto-wallets.417f8d4c.png";